import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import {
  black1,
  calloutBlueContent,
  calloutOrangeContent,
} from 'app/components/ThemeProvider/colors';
const InfoIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox='0 0 18 18'
      sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }}
      {...props}
    >
      <g clipPath='url(#clip0_711_3909)'>
        <path
          d='M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z'
          stroke={
            props.color === 'secondary'
              ? calloutBlueContent
              : props.color === 'primary'
                ? 'rgba(20, 25, 31, 0.6)'
                : props.color === 'warning'
                  ? calloutOrangeContent
                  : black1
          }
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_711_3909'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default InfoIcon;
